import { FormFieldSwitchSelect, FormFieldTime } from 'global/components/Form'
import Grid from 'global/components/ui/Grid'
import { ClockArrowUpIcon } from 'lucide-react'
import {
    type CondicaoUi,
    descreverLimite,
    OPCOES_COMPARACAO,
} from './condicao-ui'

function ParametrosHorasExtras() {
    return (
        <Grid container>
            <Grid item xs={6}>
                <FormFieldSwitchSelect
                    name="parametros.comparacao"
                    label="Duração"
                    options={OPCOES_COMPARACAO}
                />
            </Grid>
            <Grid item xs={6}>
                <FormFieldTime
                    name="parametros.limite"
                    label="Limite"
                    required
                />
            </Grid>
        </Grid>
    )
}

export const horasExtras: CondicaoUi = {
    icone: ClockArrowUpIcon,
    parametrosIniciais: { comparacao: 'acima', limite: '02:00' },
    Parametros: ParametrosHorasExtras,
    resumir: parametros => {
        const limite = descreverLimite(parametros)
        return limite.charAt(0).toUpperCase() + limite.slice(1)
    },
}
